import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-DAPmendianfuwu",
  "use": "icon-DAPmendianfuwu-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-DAPmendianfuwu\"><g fill-rule=\"nonzero\"><path d=\"M13.828 14.852H6.553c-.66 0-1.195-.536-1.195-1.196V5.964c0-.43.35-.78.78-.78h7.69c.66 0 1.195.536 1.195 1.196v7.275a1.197 1.197 0 01-1.195 1.197zm-7.69-8.94a.052.052 0 00-.052.052v7.69c0 .258.21.47.469.47h7.273a.47.47 0 00.469-.47V6.38a.47.47 0 00-.469-.47h-7.69v.002z\" /><path d=\"M9.456 10.831H2.18c-.66 0-1.196-.536-1.196-1.195V1.944c0-.43.35-.78.78-.78h7.69c.66 0 1.196.536 1.196 1.195v7.275a1.194 1.194 0 01-1.194 1.197zM1.764 1.892a.052.052 0 00-.052.052v7.69c0 .258.21.47.47.47h7.274a.47.47 0 00.469-.47V2.361a.47.47 0 00-.469-.469H1.764z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/DAPmendianfuwu.svg
// module id = 443
// module chunks = 4